import React from 'react';
import PropTypes from 'prop-types';

import CommonSwapIcon from 'components/common/link-elements/CommonSwapIcon';
import ProductItemThumbnail
  from 'components/dashboard/catalog-content/ProductItemThumbnail';
import ProductItemName from 'components/dashboard/catalog-content/ProductItemName';
import ProductItemPrice from 'components/dashboard/catalog-content/ProductItemPrice';
import ProductItemUrl from 'components/dashboard/catalog-content/ProductItemUrl';
import ProductPublishedCheckbox
  from 'components/dashboard/catalog-content/ProductPublishedCheckbox';
import ShowProductPriceCheckbox
  from 'components/dashboard/catalog-content/ShowProductPriceCheckbox';
import ProductDeleteIcon from 'components/dashboard/catalog-content/ProductDeleteIcon';

import './CatalogProductItem.css';

const CatalogProductItem = ({ item, patchProductLinkSuccess }) => (
  <div className="catalog-product-item__component">
    <div
      className={`product-item-wrapper
        ${(patchProductLinkSuccess && patchProductLinkSuccess.id === item.id) ?
        ' pulse' : ''}`}
    >
      <div className="swap-icon-container">
        <CommonSwapIcon />
      </div>

      <div className="thumbnail">
        <ProductItemThumbnail
          productId={item.id}
          thumbnail={item.thumbnail}
        />
      </div>

      <div className="title-price">
        <ProductItemName
          productId={item.id}
          name={item.name}
        />

        <ProductItemPrice
          productId={item.id}
          initialPrice={item.price}
          initialCurrency={item.currency}
        />
      </div>

      <div className="link-container">
        <ProductItemUrl
          url={item.url}
          productId={item.id}
        />
        <ShowProductPriceCheckbox
          productId={item.id}
          showPrice={item.show_price}
        />
      </div>

      <div className="actinons-block">
        <ProductPublishedCheckbox
          productId={item.id}
          isPublished={item.is_published}
        />
        <ProductDeleteIcon productId={item.id} />
      </div>
    </div>
  </div>
);

CatalogProductItem.propTypes = {
  item: PropTypes.object.isRequired,
  patchProductLinkSuccess: PropTypes.object,
};

CatalogProductItem.defaultProps = {
  patchProductLinkSuccess: null,
};

export default CatalogProductItem;
